import apiService from './ApiService';

class ObservabilidadApiService {
  async getGlobalErrors({ from, to, colegioId, profesorParticularId, tipoTenant, handled, nivel, search } = {}) {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    if (colegioId) params.append('colegioId', colegioId);
    if (profesorParticularId) params.append('profesorParticularId', profesorParticularId);
    if (tipoTenant && tipoTenant !== 'todos' && tipoTenant !== 'all') params.append('tipoTenant', tipoTenant);
    if (handled && handled !== 'all') params.append('handled', handled);
    if (nivel && nivel !== 'all') params.append('nivel', nivel);
    if (search) params.append('search', search);
    const qs = params.toString();
    return apiService.get(`/observabilidad/errores-generales${qs ? `?${qs}` : ''}`);
  }

  async purgeExpiredErrors() {
    return apiService.post('/observabilidad/errores-generales/purgar-vencidos', {});
  }

  async forcePurgeErrors({ from, to } = {}) {
    return apiService.post('/observabilidad/errores-generales/forzar-purgado', {
      from: from || null,
      to: to || null
    });
  }
}

const observabilidadApiService = new ObservabilidadApiService();

export default observabilidadApiService;
